import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import Link from 'next/link';

import { ChevronDownIcon } from '@/ui/Icons/ChevronDownIcon';

import {
  NETWORK_NAME_FOR_URLPATH_PER_CHAIN_ID,
  SUPPORTED_CHAIN_IDS_CROSS_CHAIN,
  SUPPORTED_CHAINS_BY_CHAIN_ID,
} from '../../../constants/chain';
import { useMatchaWallets } from '../../../hooks/useMatchaWallets';
import { buttons } from '../../../styles/buttons';
import { popover } from '../../../styles/popover';
import { fontStyles } from '../../../styles/typography';
import { routes } from '../../../utils/routes';
import { getConnectedChain } from '../../../utils/wallet';
import { FeaturesPageNavigationMenu } from '../FeaturesPageNavigationMenu';
import { HeaderBase } from '../HeaderBase';
import { MatchaLogoButton } from '../MatchaLogoButton';
import { NavigationDropdownList } from '../NavigationDropdownList';

export function MarketingPageHeader() {
  const { base } = popover();
  const { ethereumWallet } = useMatchaWallets();
  const evmChain = getConnectedChain(ethereumWallet);
  const isChainIdSupportedForCrossChain =
    evmChain !== undefined && SUPPORTED_CHAIN_IDS_CROSS_CHAIN.indexOf(evmChain.id) !== -1;
  return (
    <HeaderBase>
      <div className="flex items-center">
        <MatchaLogoButton />
      </div>
      <div className="items-center justify-center hidden tablet:flex">
        <FeaturesPageNavigationMenu />
      </div>
      <nav className="flex gap-2 justify-end">
        <Link
          href={{
            pathname: routes.TOKEN_PROFILE,
            query: {
              chainId:
                evmChain !== undefined
                  ? NETWORK_NAME_FOR_URLPATH_PER_CHAIN_ID[evmChain.id]
                  : 'ethereum',
              contractAddresses: [
                isChainIdSupportedForCrossChain
                  ? SUPPORTED_CHAINS_BY_CHAIN_ID[evmChain.id]?.nativeCurrency.symbol.toLowerCase()
                  : 'eth',
              ],
            },
          }}
        >
          <div
            className={buttons({
              size: 'medium',
              color: 'black',
              shape: 'pill',
            })}
          >
            Open App
          </div>
        </Link>

        <DropdownMenu.Root modal={false}>
          <DropdownMenu.Trigger
            className={buttons({
              size: 'small',
              color: 'transparent',
              shape: 'rounded',
              class: [
                'h-10',
                'p-4',
                'cursor-default',
                'whitespace-nowrap',
                'rounded-full',
                'hover:bg-token-alphalight-200',
                'disabled:bg-token-alphalight-200',
                'disabled:cursor-none',
                'disabled:border',
                'disabled:border-solid',
                'disabled:border-token-gray-300',
                'tablet:hidden',
              ],
            })}
          >
            <span className={fontStyles({ variant: 'LABEL_MD' })}>Menu</span>
            <ChevronDownIcon className="text-token-gray-700 ml-1" />
          </DropdownMenu.Trigger>

          <DropdownMenu.Portal>
            <DropdownMenu.Content align="end" className={base({ class: 'max-w-[332px]' })}>
              <NavigationDropdownList isInFeaturesPage />
            </DropdownMenu.Content>
          </DropdownMenu.Portal>
        </DropdownMenu.Root>
      </nav>
    </HeaderBase>
  );
}
